import { Redirect, type ExpoRouter } from 'expo-router'
import { useStatementScreenParams } from '@/src/experiences/card-statements/Statement/createUseStatementScreenProps'

const pathname = '/main/card/card-management/statements/[id]' satisfies ExpoRouter.__routes['href']

/** @deprecated use `/main/card/card-management/statements/[id]` instead */
export default function DeprecatedViewStatementScreen() {
  const params = useStatementScreenParams()
  return <Redirect href={params ? { pathname, params } : pathname} />
}
